import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $accountByIdStore } from '@lib/store';
import { cn } from '@shared/utils';
import { AccountType } from '@shared/api';
import { AccountSidebar } from './card';
import { AccountDetails, Documents } from './payment';
import { SidebarSection } from './sidebarSection';

interface SidebarProps {
  className?: string;
}

export const Sidebar = (props: SidebarProps) => {
  const accountDetailsStore = useUnit($accountByIdStore.store);

  const { t } = useTranslation('account');

  if (!accountDetailsStore.data) return null;
  return (
    <aside className={cn('flex h-fit w-full max-w-80 shrink-0 flex-col gap-6', 'max-xl:max-w-none', props.className)}>
      {accountDetailsStore.data.type === AccountType.Card && <AccountSidebar />}
      {accountDetailsStore.data.type === AccountType.Payment && (
        <>
          <SidebarSection caption={t('sidebar.accountDetails.title')}>
            <AccountDetails />
          </SidebarSection>
          <SidebarSection caption='Documents'>
            <Documents />
          </SidebarSection>
        </>
      )}
    </aside>
  );
};
